import styled from 'styled-components';
import CS from '../styles/componentStyled'
import { loadingSpinnerState } from '../atom/ModalAtom';
import { useRecoilState } from'recoil';

const LoadingSpinner = () => {
    const [loadingState, setLoadingState] = useRecoilState(loadingSpinnerState);

    return (
        <>
            {loadingState &&
                <CS.ModalBg>
                    <ItemBox className='flex fdc aic jcc'>
                        <Item/>
                        <p>처리 중이니, 잠시만 기다려주세요.</p>
                    </ItemBox>
                </CS.ModalBg>
            }
        </>
    );
}

export default LoadingSpinner;

const ItemBox = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    gap: 8px;
    
    > p {
        font-size: 14px;
        color: #fff;
    }
`

const Item = styled.div`   
    width: 40px;
    height: 40px;
    border: 5px solid #12ACB0;
    border-top: 5px solid transparent;
    border-radius: 50%;
    animation: rotate 1s linear infinite;

    @keyframes rotate {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`